export const pngs = {
  autobiography: require("../../assets/png/autobio.png"),
  writeAStory: require("../../assets/png/another-story.png"),
  writeASelfDev: require("../../assets/png/self-dev.png"),
};
